export enum ResolutionEnum{
    NONE = "NONE",
    EXTENSION =  "EXTENSION",
    TR =  "TR"
}